<template>
  <div v-if="loading">
    <v-flex offset-xs5 pa-5>
      <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
    </v-flex>
  </div>
  <div v-else>
    <DataTable :headers="headers" :path="path" actionButtonsName="CuotasListActionButtons" :properties="properties"
    filter :filterPath="filterPath" ref="tablaCuotas">
    </DataTable>
  </div>
</template>

<script>
import { paginationMixin } from '../../../mixins/paginationMixin'
import DataTable from '../../../common/ui/DataTable'

export default {

  mixins: [paginationMixin],

  components: {
    DataTable
  },

  data () {
    return {
      path: `/deuda/${this.$route.params.id}/cuotas`,
      filterPath: `filter/cuotas`,
      loading: false,
      customPagination: {
        page: 1,
        descending: false,
        rowsPerPage: -1
      }
    }
  },

  filters: {
    formatAsCurrency (importe) {
      return Number(importe).toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  },
  methods: {
    refreshTable () {
      this.$refs.tablaCuotas.fetchData()
    }
  },

  created () {
  },

  computed: {
    deudaId () {
      return this.$route.params.id
    },
    headers () {
      let headers = [
        { text: 'Vencimiento', value: 'fechaVencimiento', sortable: false },
        { text: 'Importe', value: 'importe', sortable: false },
        { text: 'Estado', value: 'estado', sortable: false, filterField: true },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      return headers
    },
    properties () {
      const propiedades = ['fechaVencimiento',
        'importeDisplay',
        'estadoDisplay']
      return propiedades
    }
  }
}
</script>
<style scoped>
</style>
